import "./blobLoader.css";

export const BlobLoader = () => {
  return (
    <div className="blob-wrapper">
      <div className="blob"></div>
    </div>
  )
};
